export const maxThresholdForResults = 9999; // Disclaimer: Max threshold for the query
